import React from "react";

const Footer = (): React.ReactElement => {
  return (
    <footer className="py-3 sm:py-2 max-[391px]:text-xs max-[480px]:text-sm">
      <div className="flex max-sm:flex-col items-center gap-2.5 justify-end">
        <p className="text-center">
          © {new Date().getFullYear()} Automation Industries Pty Ltd. All Rights
          Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
